import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Афиша")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Нет данных")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_sheet = _resolveComponent("v-sheet")!

  return (_ctx.userData)
    ? (_openBlock(), _createBlock(_component_v_sheet, { key: 0 }, {
        default: _withCtx(() => [
          _hoisted_1,
          _createVNode(_component_v_card_title, null, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }),
          _createVNode(_component_v_divider),
          (!_ctx.events)
            ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                key: 0,
                indeterminate: ""
              }))
            : (!Object.keys(_ctx.events).length)
              ? (_openBlock(), _createBlock(_component_v_card_text, { key: 1 }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
          _createVNode(_component_v_sheet, {
            width: "380",
            class: "d-inline-flex flex-column justify-start"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.events, (event) => {
                return (_openBlock(), _createBlock(_component_v_card, {
                  key: event.id,
                  class: "ma-3",
                  elevation: "0",
                  style: {"cursor":"pointer"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_title, {
                      onClick: ($event: any) => (_ctx.$router.push(`/event/${event.id}?eventName=${event.name}&eventDate=${event.date}`))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(event.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_v_card_subtitle, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString((new Date(event.date).toLocaleDateString())) + " в " + _toDisplayString(event.place), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}